import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "dotHorizontal"
const DotHorizontalIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.625 10.125C6.661 10.125 7.5 10.965 7.5 12S6.66 13.875 5.625 13.875 3.75 13.035 3.75 12 4.59 10.125 5.625 10.125M12 10.125C13.036 10.125 13.875 10.965 13.875 12S13.035 13.875 12 13.875 10.125 13.035 10.125 12 10.965 10.125 12 10.125M18.375 10.125C19.41 10.125 20.25 10.965 20.25 12S19.41 13.875 18.375 13.875 16.5 13.035 16.5 12 17.34 10.125 18.375 10.125" />
        </svg>
      }
    </span>
  )
}
export default DotHorizontalIcon
